import React, { useEffect, useState } from "react";
import DataLoader from "../Dashboard/Loader";
import { getTopParticipantApi } from "../../../services/QuizService";

const DisplayTopScorer = ({ quizId }) => {
    const [scorer, setScorer] = useState([]);
    const [isScorerLoading, setScorerLoading] = useState(false);
  
    useEffect(() => {
      const fetchTopScorer = async () => {
        setScorerLoading(true);
        try {
          const response = await getTopParticipantApi(quizId);
          const results = response.data.results;
          setScorer(results);
        } catch (error) {
          console.error("Error fetching quiz!", error);
        } finally {
          setScorerLoading(false);
        }
      };
      fetchTopScorer();
    }, [quizId]);
  
    return (
      <div className="card bg-primary text-white">
        <div className="card-body">
          <h3 className="text-white">Top Scorer</h3>
          {isScorerLoading ? (
            <DataLoader />
          ) : scorer.length > 0 ? (
            scorer.map((item) => (
              <div key={item.id} className="my-3">
                <div className="d-flex align-items-center justify-content-between">
                  <span className="fw-bold">{item.user.name}</span>
                  <span className="ms-3">
                    <span className="badge border-0 bg-white text-primary">{item.score}</span>
                  </span>
                </div>
              </div>
            ))
          ) : (
            <h4>No Data Found</h4>
          )}
        </div>
      </div>
    );
  };
  

export default DisplayTopScorer